import React, { useState } from 'react';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import CommonHeader from '../../../common/CommonHeader';
import { ArrowLeftOutlined } from '@ant-design/icons';
import '../../../components/superAdmin/dashboard/CustomNavbar.css';
import Banner from "../../../assets/image/banner.png";

const SubAdminHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [hoverStates, setHoverStates] = useState({});
    const [permissions, setPermissions] = useState(() => {
        return JSON.parse(localStorage.getItem('subAdminPermissions') || '{}');
    });

    const isDashboard = location.pathname === '/subadmin/dashboard';

    React.useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const token = localStorage.getItem('jff_token');
                if (!token) return;

                const response = await axios.get(`${process.env.REACT_APP_API_END_POINT}/subadmin/dashboard`, {
                    headers: { token }
                });
                const freshPerms = response.data.permissions;
                setPermissions(freshPerms);
                localStorage.setItem('subAdminPermissions', JSON.stringify(freshPerms));
            } catch (error) {
                console.error("Error syncing permissions:", error);
            }
        };
        fetchPermissions();
    }, [location.pathname]);

    const handleLogout = () => {
        localStorage.clear();
        navigate("/subadmin/login");
    };

    const toggleHover = (key, state) => {
        setHoverStates(prev => ({ ...prev, [key]: state }));
    };

    const renderNavItems = () => {
        const items = [];

        // Dashboard
        items.push(
            <Nav.Link key="dashboard" onClick={() => navigate("/subadmin/dashboard")}>
                Dashboard
            </Nav.Link>
        );

        // Area List
        if (permissions.areaList?.enabled) {
            items.push(
                <Nav.Link key="area" onClick={() => navigate("/subadmin/areas")}>
                    Area
                </Nav.Link>
            );
        }

        // Exhibitor
        if (permissions.exhibitorList?.enabled) {
            items.push(
                <Nav.Link key="exhibitor" onClick={() => navigate("/subadmin/exhibitors")}>
                    Exhibitor
                </Nav.Link>
            );
        }

        // Hosted Buyer Dropdown
        const buyerSubLinks = [];
        if (permissions.buyersList?.buyersRequestList?.enabled)
            buyerSubLinks.push({ label: 'Hosted Buyers Request List', path: '/subadmin/buyers/requests' });
        if (permissions.buyersList?.buyersInvitedList?.enabled)
            buyerSubLinks.push({ label: 'Invited Hosted Buyers List', path: '/subadmin/buyers/invited' });
        if (permissions.buyersList?.buyersHostedRecycledList?.enabled)
            buyerSubLinks.push({ label: 'Hosted Recycled Buyers List', path: '/subadmin/buyers/recycled' });
        if (permissions.buyersList?.buyersOldList?.enabled)
            buyerSubLinks.push({ label: 'Old Buyers List', path: '/subadmin/buyers/old' });

        if (buyerSubLinks.length > 0) {
            items.push(
                <NavDropdown
                    key="buyer"
                    title="Hosted Buyer"
                    id="buyer-dropdown"
                    show={hoverStates['buyer']}
                    onMouseEnter={() => toggleHover('buyer', true)}
                    onMouseLeave={() => toggleHover('buyer', false)}
                >
                    {buyerSubLinks.map((link, idx) => (
                        <NavDropdown.Item key={idx} onClick={() => navigate(link.path)}>
                            {link.label}
                        </NavDropdown.Item>
                    ))}
                </NavDropdown>
            );
        }

        // Visitor
        if (permissions.visitorsList?.enabled) {
            items.push(
                <Nav.Link key="visitor" onClick={() => navigate("/subadmin/visitors")}>
                    Visitor
                </Nav.Link>
            );
        }

        return items;
    };

    return (
        <>
            <div style={{ position: 'sticky', top: 0, zIndex: 1050, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                <Navbar className="custom-navbar" expand="lg">
                    <div className="d-flex align-items-center">
                        {!isDashboard && (
                            <button
                                className="btn btn-link text-white p-0 ms-3 d-flex align-items-center"
                                onClick={() => navigate(-1)}
                                style={{ textDecoration: 'none', fontSize: '18px' }}
                                title="Back"
                            >
                                <ArrowLeftOutlined />
                            </button>
                        )}
                        <CommonHeader redirection="/subadmin/dashboard" />
                    </div>

                    <Container>
                        <Navbar.Toggle aria-controls="subadmin-navbar-scroll" />
                        <Navbar.Collapse id="subadmin-navbar-scroll">
                            <Nav className="me-auto my-2 my-lg-0" navbarScroll>
                                {renderNavItems()}
                                <NavDropdown
                                    key="setting"
                                    title="Setting"
                                    id="setting-dropdown"
                                    show={hoverStates['setting']}
                                    onMouseEnter={() => toggleHover('setting', true)}
                                    onMouseLeave={() => toggleHover('setting', false)}
                                >
                                    <NavDropdown.Item onClick={() => navigate("/subadmin/change-password")}>
                                        Change Password
                                    </NavDropdown.Item>
                                    <NavDropdown.Item onClick={handleLogout}>
                                        Logout
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>

                    </Container>
                </Navbar>
            </div>
            <div>
                <div className="d-flex justify-content-center align-items-center">
                    <img
                        src={Banner}
                        alt="banner-img"
                        className="my-1 mx-5"
                        style={{ height: "90px", width: "970px", cursor: 'pointer' }}
                        onClick={() => navigate("/subadmin/dashboard")}
                    />
                </div>
            </div>
        </>
    );
};

export default SubAdminHeader;
